// This file configures the initialization of client-side observability.
// The config you add here will be used whenever a user loads a page in their browser.

import { initDatadogLogs, initDatadogRUM } from '@/lib/observability/rum';

// Initialize Datadog RUM (Real User Monitoring) for client-side observability
// This runs on the client regardless of server runtime (nodejs or edge)
try {
  initDatadogRUM();
  initDatadogLogs();
} catch (error) {
  // Can't use logger here as it may not be initialized yet
  // This is early initialization code that runs before the app starts
  if (typeof window !== 'undefined') {
    console.warn('Failed to initialize Datadog RUM and Logs:', error);
  }
}
